export const twoToThreeCountryCode: { [code: string]: string } = {
    ae: 'UAE', //UAE
    bh: 'BRN', //Bahrain
    iq: 'IRQ', //Iraq
    jo: 'JOR', //Jordan
    kw: 'KUW', //Kuwait
    lb: 'LEB', //Lebanon
    om: 'OMA', //Oman
    qa: 'QAT', //Qatar
    sa: 'KSA', //Saudi Arabia
    ye: 'YEM', //Yemen
    dz: 'ALG', //Algeria
    mr: 'MAU', //Mauritania
    td: 'CHA', //Chad
    tn: 'TUN', //Tunisia
    ly: 'LIB', //Libiya
    eg: 'EGY', //Egypt
    ma: 'MOR', //Morocco
};
